module.exports = __webpack_public_path__ + "media/images/map/read_less_image-90a33d0c7d9bee74a2000409fa201d13.svg";